// test2469
(2469 && 0);
